/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { FeedPage } from './pages/FeedPage';
import { MarketplacePage } from './pages/MarketplacePage';
import { VendorsPage } from './pages/VendorsPage';
import { CommunityPage } from './pages/CommunityPage';
import { AdminDashboard } from './pages/AdminDashboard';
import { SeedPage } from './pages/SeedPage';
import { VendorProfilePage } from './pages/VendorProfilePage';
import { ProductPage } from './pages/ProductPage';
import { VendorDashboard } from './pages/VendorDashboard';
import { AuthProvider } from './contexts/AuthContext';
import { LoginPage } from './pages/LoginPage';
import { AddListingPage } from './pages/AddListingPage';
import { ProfilePage } from './pages/ProfilePage';
import { ChatPage } from './pages/ChatPage';

const Placeholder = ({ title }) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
    <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center text-gray-300 mb-6">
      <h2 className="text-4xl">?</h2>
    </div>
    <h1 className="text-2xl font-bold text-gray-900 mb-2">{title}</h1>
    <p className="text-gray-500 max-w-md">
      This page is part of our upcoming industry-first digital platform.
      The core MVP elements of Feed and Marketplace are already live!
    </p>
  </div>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<FeedPage />} />
            <Route path="/marketplace" element={<MarketplacePage />} />
            <Route path="/news" element={<Placeholder title="Industry News Portal" />} />
            <Route path="/events" element={<Placeholder title="Global Events Module" />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/vendors" element={<VendorsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/vendor/dashboard" element={<VendorDashboard />} />
            <Route path="/seed" element={<SeedPage />} />
            <Route path="/vendors/:id" element={<VendorProfilePage />} />
            <Route path="/listings/:id" element={<ProductPage />} />
            <Route path="/add-listing" element={<AddListingPage />} />
            <Route path="/messages" element={<ChatPage />} />
            <Route path="/login" element={<LoginPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </AuthProvider>
  );
}
